import User from "../models/User";
import AgencyOpportunity from "../models/AgencyOpportunity";


const fetchSupplierDashboard = async ({queryKey, signal}) => {
    const SupplierStatsRequest = TB.request(
        TB.api_endpoint(`/api/talent-dashboard`)
    )

    let response = await SupplierStatsRequest.get({signal}).catch(console.warn);

    if (!response || !TB.has(response, 'success.data')) {
        throw new Error('Something went wrong')
    }

    return response.success.data;
}
const fetchTalentResourcesForJobBoard = async ({queryKey, signal}) => {
    const clientId = queryKey[1];

    const FetchAllForClientRequest = TB.request(
        TB.api_endpoint(`/api/clients/${clientId}/users/supplied-talent/byo`)
    );

    let response = await FetchAllForClientRequest.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.users')) {
        throw new Error('Something went wrong')
    }

    return User.makeMany(
        response.success.data.users
    );
}

const fetchOpportunityForAgency = async ({queryKey, signal}) => {
    const oppId = queryKey[1] || {}
    return AgencyOpportunity.fetchDetails(oppId, {signal})
}
const fetchAllSupplierOpportunities = async ({queryKey, signal}) => {
    const params = queryKey[1] || {}
    return AgencyOpportunity.fetchAllForSupplierResourceManager(params, {signal})
}
const fetchAllSupplierTalentResources = async ({queryKey, signal}) => {
    const clientId = queryKey[1];

    const FetchAllForClientRequest = TB.request(
        TB.api_endpoint(`/api/clients/${clientId}/users`), {type: laravel.user_types.talent}
    );

    let response = await FetchAllForClientRequest.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.users')) {
        throw new Error('Something went wrong')
    }

    return TB.filter(User.makeMany(
        response.success.data.users
    ), user => user.isTalent());
}
const fetchSupplierTalentResource = ({queryKey, signal}) => {
    const talentUserId = queryKey[1] || {};  // queryKey[0] is the original query key

    return User.fetchTalentSupplierResource(talentUserId, {signal});
}

export {
    fetchSupplierDashboard,
    fetchAllSupplierOpportunities,
    fetchSupplierTalentResource,
    fetchAllSupplierTalentResources,
    fetchTalentResourcesForJobBoard,
    fetchOpportunityForAgency
}